export default __webpack_public_path__ + "static/media/hero.42e83950.png";